import React from 'react';
import { Box, Spinner } from '@indeed/ifl-components';
import { PageablePDFPreview } from '@indeed/jspl-pdf';
import GettextFactory from '../../../util/GettextFactory';

export interface FileResumePreviewProps {
    /**
     * URL to the PDF file
     */
    fileUrl: string | null;
    /**
     * Name of the file (optional, for accessibility)
     */
    fileName?: string;
    /**
     * Whether the PDF is currently loading
     */
    loading?: boolean;
    /**
     * Whether to show border around the preview
     * @default true
     */
    showBorder?: boolean;
}

/**
 * Shared component for displaying PDF resume preview
 * Used in both ResumePage and ReviewPage to ensure consistent styling and behavior
 */
export const FileResumePreview: React.FC<FileResumePreviewProps> = ({
    fileUrl,
    fileName,
    loading = false,
    showBorder = true,
}) => {
    const gt = GettextFactory();

    if (loading) {
        return (
            <Box sx={{ padding: 4, textAlign: 'center' }}>
                <Spinner title={gt.gettext('Loading resume preview')} />
            </Box>
        );
    }

    if (!fileUrl) {
        return null;
    }

    return (
        <Box
            sx={{
                inlineSize: '100%',
                borderRadius: 'md',
                ...(showBorder && {
                    border: '1px solid',
                    borderColor: 'border.weak',
                }),
            }}
        >
            <PageablePDFPreview fileUrl={fileUrl} fileName={fileName} />
        </Box>
    );
};
